import AddToCartChoiceModal from "../Modals/AddToCartChoiceModal";
import { AccountModeModalStoreImplementation } from "Data/AccountModeModal/AccountModeModalStoreImplementation";
import { useNavigate, useLocation } from "react-router-dom";

export const GlobalAccountModeModal: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { modalState, closeAccountModeModal, chooseGuestMode } =
    AccountModeModalStoreImplementation();

  return (
    <AddToCartChoiceModal
      modalVisibility={modalState.visible}
      onContinueAsGuest={() => {
        chooseGuestMode();
      }}
      onLogin={() => {
        closeAccountModeModal();
        navigate("/auth/login", {
          state: {
            returnTo: {
              pathname: location.pathname,
              search: location.search,
              hash: location.hash,
            },
            from: "account-mode-modal",
          },
        });
      }}
      onClose={closeAccountModeModal}
    />
  );
};
